var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3Sistssoffa01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 228.15 118.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-2.71 150.92 241.22 150.92 241.22 -8.2 -2.71 -8.2 -2.71 150.92"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "25.04 35.69 83.84 35.69 83.84 101.81 25.04 101.81 25.04 35.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "83.84 35.69 142.61 35.69 142.61 101.81 83.84 101.81 83.84 35.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "142.61 35.69 201.41 35.69 201.41 101.81 142.61 101.81 142.61 35.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "201.41 97.1 212.42 97.1 212.42 26.24 201.41 26.24 201.41 97.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "25.04 97.1 14.03 97.1 14.03 26.24 25.04 26.24 25.04 97.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "212.42 26.24 14.03 26.24 14.03 16.79 212.42 16.79 212.42 26.24"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "25.04 26.24 201.41 26.24 201.41 35.69 25.04 35.69 25.04 26.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Sistssoffa01);
export default __webpack_public_path__ + "static/media/3 sists soffa-01.820b1cb2c3cba221e1b38c237a301bc9.svg";
export { ForwardRef as ReactComponent };